<script setup>
    defineProps({
        value: String,
        isRequired: Boolean,
        helperText: String,
    })
</script>

<template>
    <label class="block text-sm font-medium text-gray-700">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>
        <span
            v-if="isRequired"
            class="text-red-500"
            >*</span
        >
        <p
            v-if="helperText"
            class="text-xs text-gray-500"
        >
            ({{ helperText }})
        </p>
    </label>
</template>
